import React from "react";
import { MessageCircle, Send } from "lucide-react";
import { contactInfo } from "@/i18n/translations";
import { useLanguage } from "@/context/LanguageContext";
import { trackEvent } from "@/lib/analytics";

const WhatsAppFab = () => {
  const { t } = useLanguage();
  return (
    <div className="fixed bottom-6 right-6 z-40 flex flex-col gap-3 items-end">
      <a
        href={`https://t.me/+${contactInfo.whatsapp}`}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Telegram"
        onClick={() => trackEvent("telegram_click", { surface: "fab" })}
        className="flex items-center gap-3 bg-[#229ED9] text-white pl-4 pr-5 py-3 shadow-[0_10px_40px_rgba(34,158,217,0.35)] hover:shadow-[0_10px_50px_rgba(34,158,217,0.5)] transition-all hover:-translate-y-0.5"
        data-testid="telegram-fab-button"
      >
        <Send size={18} strokeWidth={2} />
        <span className="hidden sm:inline text-[11px] tracking-[0.2em] uppercase font-semibold">
          Telegram
        </span>
      </a>
      <a
        href={`https://wa.me/${contactInfo.whatsapp}`}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={t.whatsapp}
        onClick={() => trackEvent("whatsapp_click", { surface: "fab" })}
        className="flex items-center gap-3 bg-[#25D366] text-navy pl-4 pr-5 py-3 shadow-[0_10px_40px_rgba(37,211,102,0.35)] hover:shadow-[0_10px_50px_rgba(37,211,102,0.5)] transition-all hover:-translate-y-0.5"
        data-testid="whatsapp-fab-button"
      >
        <MessageCircle size={18} strokeWidth={2} />
        <span className="hidden sm:inline text-[11px] tracking-[0.2em] uppercase font-semibold">
          WhatsApp
        </span>
      </a>
    </div>
  );
};

export default WhatsAppFab;
